// Copyright (c) StrangeBee 2023

import { ReactElement, memo } from 'react';

interface ThumbnailIconProps {
    icon: ReactElement;
}

export const ThumbnailIcon = memo(
    ({ icon }: ThumbnailIconProps): ReactElement => <div className="Comment__ThumbnailContainer">{icon}</div>,
);
